module.exports = __webpack_public_path__ + "img/tool1.c42ff940.png";